import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import authQueries from "../../../queries/authQueries";
import * as yup from 'yup';
import { Link, useNavigate } from "react-router-dom";

const RoleAdd =()=>{

    const validationSchema = yup.object({
        name: yup
          .string('⚠ Enter your Name')
          .required('⚠ Name is required')
          .min(2, '⚠ Name should be of Minimum of 2 characters length'),
        label: yup
          .string('⚠ Enter your Label')
          .required('⚠ Label is required')
          .min(2, '⚠ Name should be of Minimum of 2 characters length'),
        status: yup
          .string('⚠ Enter your status')
          .required('⚠ Status is required'),
    });

      
    const [result, setResult] = useState([]);
    const [errName, setErrName] = useState('');

    const navigate = useNavigate();


    const { register , control, handleSubmit, formState:{ errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });


    const addProgram = authQueries.useRoleMutationAdd(
        (response) => {
            if(response?.message === "Success"){
                navigate('/role')
            }else if(response?.error[0].name){
                setErrName("⚠ "+response?.error[0].name)
            }
        }   
    );
        
    
    const onSubmit = (data) => {
        console.log(data);
        const datavalues = {
            name: data.name,
            label: data.label,
            status: data.status,
        };
        
        addProgram.mutateAsync(datavalues);
    }
    

    
    return(
        <div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/role">Role List</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Add Role</li>
                </ol>
            </nav>

            <div className="add_clients">
                <div className="card">
                    <div className="card-header">
                        Create Role
                    </div>
                    <div id="intended_college_program" className="collapse show" data-parent="#accordion">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        
                                            <div id="parent" className="form-group">
                                                <label >Name</label>
                                                <input 
                                                    {...register("name")}
                                                    type="text" 
                                                    className="form-control"  
                                                    name="name"/>
                                                <div className='error-msg'>{errors.name?.message}{errName}</div>
                                            </div>
                                            <div id="output"></div>
                                        
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        
                                            <div id="parent" className="form-group">
                                                <label >Label</label>
                                                <input 
                                                    {...register("label")}
                                                    type="text" 
                                                    className="form-control"  
                                                    name="label"/>
                                                <div className='error-msg'>{errors.label?.message}</div>
                                            </div>
                                            <div id="output"></div>
                                        
                                    </div>
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="form-group">
                                        
                                            <div id="parent" className="form-group">
                                                <label >Status</label>
                                                <select  {...register("status")}  className="form-control"  name="status">
                                                    <option value="">Select</option>
                                                    <option value="ACTIVE">ACTIVE</option>
                                                    <option value="INACTIVE">INACTIVE</option>
                                                </select>       
                                                <div className='error-msg'>{errors.status?.message}</div>
                                            </div>

                                            <div id="output"></div>
                                        
                                    </div>
                                </div>                                                       
                                
                                <div className="col-md-12 text-center">
                                    <button type="submit" className="btn btn-default btn-save">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
            </div>


        </div>
    )
}

export default RoleAdd